import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';

export const ChoosePCPCardContainer = styled(Flex, {
  minHeight: '313px',
  gap: '8px',
  border: ' 1px dashed $lightGrey',
  padding: '32px 16px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  '.abyss-flex-root': {
    textAlign: 'center',
  },

  '@media (min-width: 745px)': {
    width: '282px',
  },
  '@media (max-width: 744px)': {
    display: 'flex',
    width: '90%',
    marginBottom: '20px',
  },
});

export const CareTeamEmptyCardContainer = styled(Flex, {
  display: 'flex',
  minHeight: '313px',
  gap: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  border: ' 1px solid $lightGrey',
  padding: '12px 60px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'flex-start',

  // Default - one PCP (either current OR future)
  '@media (min-width: 745px)': {
    flex: 1,
    maxWidth: '896px',
    maxHeight: '391px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '0px',
    width: '90%',
    flexDirection: 'column',
    margin: '12px 60px',
    padding: '50px 60px',
  },
  variants: {
    pcpStatus: {
      // No PCP
      none: {
        '@media (min-width: 745px)': {
          maxWidth: '896px',
          maxHeight: '365px',
        },
      },
      // Both current + future PCP - centered layout
      both: {
        justifyContent: 'center',
        alignItems: 'center',
        gap: '48px',
        borderRadius: '8px',
        border: '1px solid #E5E5E6',
        background: '#FFF',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
        '@media (min-width: 745px)': {
          maxWidth: '588px',
          maxHeight: '365px',
        },
      },
    },
  },
});

export const CareTeamEmptyCardStyle = styled('div', {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  '@media (min-width: 745px)': {
    flex: 1,
    justifyContent: 'space-around',
  },
  '@media (max-width: 744px)': {
    marginLeft: '0px',
    flexDirection: 'column-reverse',
  },

  variants: {
    pcpStatus: {
      // Both current + future PCP - centered column layout
      both: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '32px',
      },
    },
  },
});

export const CareTeamEmptyCardHeader = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  '@media (min-width: 745px)': {},
  '@media (max-width: 744px)': {
    marginTop: '20px',
    width: '95%',
    textAlign: 'center',
  },
  variants: {
    pcpStatus: {
      // Both current + future PCP - centered text
      both: {
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      },
    },
  },
});

export const CareTeamEmptyCardData = styled('div', {
  '@media (max-width: 744px)': {
    marginBottom: '25px',
  },
});

export const CareProviderImage = styled('div', {
  width: '70px',
  height: '70px',
  margin: '0px 16px',
  backgroundColor: '$snackCardAvatarBackgroundColor',
  borderRadius: '50%',
  border: '1px solid #F3F3F3',
  overflow: 'hidden',
  '@media (max-width: 464px)': {
    width: '55px',
    height: '55px',
    margin: '0px 8px',
  },
});

export const CareProviderContainer = styled('div', {
  dynamic: ({ cssProps: { index } = {} }) => ({
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: index !== 0 ? '20px' : '0px',
  }),
});

export const CareTeamSkeleton = styled('div', {
  variants: {
    size: {
      md: {
        background: '$lightGrey2',
        width: '150px',
        height: '10px',
        marginTop: '3px',
        marginBottom: '15px',
        borderRadius: '20px',
      },
      lg: {
        background: '$lightGrey2',
        marginTop: '5px',
        minWidth: '200px',
        height: '10px',
        borderRadius: '20px',
        '@media (max-width: 464px)': {
          minWidth: '150px',
        },
      },
    },
  },
});

export const InfoPopoverContainerStyle = {
  listStyle: 'disc',
  paddingLeft: '20px',
  paddingRight: '10px',
  fontSize: '14px',
  lineHeight: '20px',
  margin: '20px 0',
};

export const InfoPopoverListStyle = {
  fontSize: '14px',
  lineHeight: '18px',
  marginBottom: '4px',
};

export const InfoIconStyle = {
  'abyss-icon-symbol': {
    marginBottom: '-3.5px',
    marginLeft: '2px',
  },
};

export const ChoosePCPButton = styled(Button, {
  fontSize: '$md',
  fontWeight: '600',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '&.abyss-button-root': {
    width: '180px',
    height: '36px',
  },
});

export const ChoosePCPCnsOrIFP = styled('p', {
  lineHeight: '20px',
  fontWeight: '400',
  fontStyle: 'normal',
  fontSize: '16px',
  textAlign: 'center',
  color: 'black',
  marginBottom: '10px',
});

export const CareTeamEmptyCardHeading = styled(Heading, {
  color: 'black',
  textAlign: 'left',
  fontFamily: '$heading',
  fontSize: '28.83px',
  fontWeight: 600,
  lineHeight: '36px',
  variants: {
    pcpStatus: {
      both: {
        color: '#002677',
        textAlign: 'center',
      },
    },
  },
});

export const CareTeamEmptyCardDescription = styled(Text, {
  color: 'black',
  margin: '10px 0px 8px 0px',
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  variants: {
    pcpStatus: {
      both: {
        color: '#4B4D4F',
        textAlign: 'center',
        marginTop: '10px',
      },
    },
  },
});
